import {Card, Row} from 'antd';
import {DollarTwoTone} from "@ant-design/icons";
import {useNavigate} from "react-router";

export const ReportMenu = ({refresh, onRefresh, onApiFail}) => {
    const navigate = useNavigate();

    const onProfitClick = () => {
        navigate('/report/profit');
    }

    const profitTitle = <div>
        <div><DollarTwoTone />  Profit Report</div>
    </div>

    return <div style={{backgroundColor: "#8f8f8f"}}>
    <Row>
        <Card size="small" title={profitTitle} variant={"borderless"} style={{margin: 16, width: 300, cursor: 'pointer'}} onClick={onProfitClick}>
            <ul style={{textAlign: 'left'}}>
                <li>Compile a report on Invoices</li>
                <li>Display Profit, and Margin</li>
                <li>Selectable Date Range</li>
            </ul>
        </Card>
        <Card size="small" title="Second Report" variant={"borderless"} style={{margin: 16, width: 300}}>
            <ul style={{textAlign: 'left'}}>
                <li>Future implementation</li>
            </ul>
        </Card>
        <Card size="small" title="Third Report" variant={"borderless"} style={{margin: 16, width: 300}}>
            <ul style={{textAlign: 'left'}}>
                <li>Future implementation</li>
            </ul>
        </Card>
    </Row>

    </div>
}